import { useContext, useEffect } from "react";
import { MapContext } from "../../MapContext";
import { registerOlInteraction } from "../helpers";

import { KeyboardZoom } from "ol/interaction";

export default function KeyboardZoomInteraction(props) {
  const context = useContext(MapContext);

  const options = {
    duration: undefined,
    condition: undefined,
    delta: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, KeyboardZoom, props, options, events),
    []
  );

  return null;
}
